<template>

    <tabs-section
        class="c-field_cf"
        :has-history="visit.status === 'completed'"
        :btn-label="nextLabel"
        :title="title"
        :empty="value === ''"
        :saved="value !== null"
        @history="openHistory"
        @next="save">
        <visit-history-previous
            v-if="lastVisit !== null && previousValueExist"
            @copy="copyValue">
            {{ previousValue }}
        </visit-history-previous>

        <form-input
            type="textarea"
            :label="'Pole ' + title"
            v-model="newValue"
            speech-to-text>
        </form-input>

        <visit-history-modal ref="textHistoryModal" :title="'Pole ' + title" @fetched="updateHistory">
            <visit-history-item
                class="c-field_cf__history"
                v-for="(item, index) in fieldHistory"
                :key="index"
                :date="item.datetime"
                :author="item.physiotherapist">
                {{ item.value || '&mdash;' }}
            </visit-history-item>
        </visit-history-modal>
    </tabs-section>

</template>


<script>

import {mapGetters} from 'vuex'
import {FormInput} from 'Components/Form'
import {TabsSection} from 'Components/Tabs'

import VisitHistoryModal from 'Components/Visit/VisitHistoryModal'
import VisitHistoryItem from 'Components/Visit/VisitHistoryItem'
import VisitHistoryPrevious from 'Components/Visit/VisitHistoryPrevious'

import noReact from 'Utils/NoReact'

export default {

    name: 'VisitFieldCustomField',

    props: {
        value: String,
        title: String,
        name: String,
    },

    data() {
        return {
            fieldHistory: [],
            isLoading: false,
            newValue: noReact(this.value) || ''
        }
    },

    computed: {
        ...mapGetters(['visit', 'lastVisit']),
        lastValue() {
            return this.lastVisit[this.name]
        },
        nextLabel() {
            if (!this.isEdited || (this.value === null && this.newValue.length === 0))
                return 'Dalej'
            return 'Zapisz'
        },
        previousValue() {
            if (!this.lastValue)
                return ''
            return this.lastValue[this.title] || ''
        },
        previousValueExist() {
            return (this.previousValue !== null && this.previousValue.length > 0)
        },
        isEdited() {
            return this.newValue !== this.value
        }
    },

    methods: {
        save(nextSection) {
            if (!this.isEdited) {
                nextSection()
                return
            }
            var cfs = noReact(this.visit.custom_fields)
            console.log(cfs)
            for (let i = 0; i < cfs.length; i++) {

                if (cfs[i].key === this.title) {
                    cfs[i].content = this.newValue
                    break
                }
            }
            this.$store.dispatch('VISIT_FIELD_UPDATE', {
                id: this.$route.params.id1,
                value: cfs,
                field: this.name
            }).then((response) => {
                this.$alert.success('Przebieg wizyty', response.data.message, 2000)
                nextSection()
            }).catch((error) => {
                this.$alert.error('Przebieg wizyty', error.response.data.message)
                nextSection(false)
            })
        },
        copyValue() {
            this.newValue += noReact(this.previousValue)
        },
        openHistory() {
            this.$refs.textHistoryModal.$emit('open', this.name)
        },
        updateHistory(history) {
            this.fieldHistory = []
            for (let i = 0; i < history.length; i++) {
                history[i].value = history[i].value.filter((cf) => {
                    return cf.key === this.title
                })
                if (history[i].value.length)
                    history[i].value = history[i].value[0].content
                else
                    history[i].value = null
            }
            this.fieldHistory = history
        }
    },

    components: {
        VisitHistoryPrevious,
        VisitHistoryItem,
        VisitHistoryModal,
        FormInput,
        TabsSection
    }
}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-field_cf {

}

</style>

